<template>
  <g-dialog
    v-model="showDisclaimerDialog"
    title="Disclaimer"
    height="650"
  >
    <div
      class="h--100 primary-grey--text"
      :class="{'pa-6': !$isMobile}"
    >
      The information and services contained on our website, <a
        href="https://www.grainfox.ca"
        target="_blank"
        rel="noopener noreferrer"
      >https://www.grainfox.ca</a> (the "Website"), the GrainFox platform and app (the "GrainFox Software"),
      and/or Sinoa, the AI Grain Market Analyst within the GrainFox Software ("Sinoa"), are for educational
      and informational purposes only and are not intended to be an exhaustive or definitive examination or
      to provide you with any advice on the subject of farming, sales, field monitoring, data management,
      or farm management practices and should not be relied upon by you for such matters.

      The information and services are based on statistical and agronomic models, research, data, and the information
      that you provide. The models, research, data, and information provided to us may change over time.

      We do not guarantee any results as individual results may vary and are subject to a variety of factors
      including weather,disease and pest pressure, soil type, farm management practices, market fluctuations,
      and the accuracy of the information provided to us.

      The marketing of grain, oilseed, and special crop production involves considerable risk and notwithstanding
      the information and services we provide, you are solely responsible for your decisions and their consequences.
      The information and services are not a substitute for industry standard field monitoring, data management and
      farm management practices. You should assess whether you require additional information and, where appropriate,
      consult your agronomist, commodities broker, and other service professionals before making financial,
      risk management, and farming decisions.

      Although we believe that the information is accurate and reliable when it is posted or provided to you, we do not
      guarantee that the information will always be accurate or current, nor do we guarantee that the information or
      services will result in profits or prevent loss. We are not legally liable to any person for damages related to
      the use of or reliance on, the Website, the GrainFox Software, Sinoa, and/or the services or the information
      contained on either the Website, the GrainFox Software, or Sinoa. View more important information about capability
      and liability in our Sinoa Disclaimer, End User Licence Agreement (for the GrainFox Software and Sinoa) and/or
      Terms of Use (for the Website).
    </div>
  </g-dialog>
</template>
<script>
import GDialog from '@/components/generic/GDialog.vue';

export default {
  name: 'DashboardDisclaimer',
  components: { GDialog },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDisclaimerDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
